import { connect } from 'react-redux';
import { TableCell, Button } from '@mui/material';

const ButtonDataCell = ({ column, value, onClick }) => (
  <TableCell key={column.id}>
    <Button variant="outlined" fullWidth sx={{ wordWrap: 'break-word' }} onClick={onClick}>
      {column.render(value) || 'NONE'}
    </Button>
  </TableCell>
);

export default connect()(ButtonDataCell);
